function Footer() {
    const currentYear = new Date().getFullYear(); // Lấy năm hiện tại

    return (
        <div className="app-footer">
            <div> Bản quyền © <a href="https://tidadigi.com/" target="_blank">TIDADIGI</a> - Cloud Computing {currentYear}  </div>
        </div>
    );
}

export default Footer;